import {TdoTableActionsEnum} from './tdo-table.model';

export class TdoTableBaseItemModel {
  actions = new Array<TdoTableActionsEnum>();
  isEditMode = false;
  isSelected = false;
  editableRowColumns: string[];
  /**
   * getActionStyle This allows custom styling to be added to each action type. Override this in the derived / extending class.
   * @param actionName The incoming string from the template to evalu`ate against TdoTableActionEnum
   */
  getActionStyle(actionName: string): string {
    let retVal;
    switch (actionName) {
      case TdoTableActionsEnum.DELETE:
        retVal = 'color: var(--tdo-purple);';
        break;
      case TdoTableActionsEnum.EDIT:
        retVal = 'color: var(--tdo-blue);';
        break;
    }
    return retVal;
  }
}
